var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-ui-menu-content"}},[(_vm.menu === 'information')?_c('j-menu-info',{ref:_vm.menu,attrs:{"ai-detail":_vm.aiDetail,"form-data":_vm.formData}}):_vm._e(),_vm._v(" "),(_vm.menu === 'model')?_c('j-menu-model',{ref:_vm.menu,attrs:{"ai-detail":_vm.aiDetail,"form-data":_vm.formData}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ded6ca8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ai/jAiContent.vue
// module id = null
// module chunks = 